module.exports = __webpack_public_path__ + "img/netflix.f1702c92.jpg";